import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ChangePasswordDialogComponent } from '../../dialog/change-password-dialog/change-password-dialog.component';

@Component({
  selector: 'app-user-form',
  templateUrl: './user-form.component.html',
  styleUrls: ['./user-form.component.css']
})
export class UserFormComponent implements OnInit {

  @Input() editMode: boolean = true;
  @Input() appearance: 'outline' | 'fill' | 'standard' = 'outline';

  rightsMap = {
    'edit_datasets': false
  };

  formGroup: FormGroup;

  constructor(
    private _controlContainer: ControlContainer,
    private _dialog: MatDialog,
    private _snackBar: MatSnackBar
  ) { }

  changePassword(){
    this._dialog.open(ChangePasswordDialogComponent, {
      panelClass: 'no-padding-dialog-container'
    }).afterClosed().subscribe((result) => {
      if(result) this._snackBar.open('Das Passwort wurde erfolgreich geändert. Verwenden Sie beim nächsten Login bitte das neue Passwort', 'Ok', {
        duration: 4000
      });
    });
  }

  ngOnInit(): void {
    this.formGroup = this._controlContainer.control as FormGroup;
  }

}
